import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';

class RowItemBaoCaoDinhKy extends React.Component {

  render() {
    return (
      <tr>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='list-items-table'>
          <Link className="txt-underline txt-regular" to={`/thong-ke-bao-cao/bao-cao-dinh-ky-chi-tiet/${this.props.item.baoCaoDonViId}`}>
            {this.props.item.baoCaoTongHopInfo ? this.props.item.baoCaoTongHopInfo.tenBaoCao : ''}
          </Link>
        </td>
        <td className='txt-left'>{this.props.item.baoCaoTongHopInfo ? this.props.item.baoCaoTongHopInfo.kyBaoCaoInfo : ''}</td>
        <td className='txt-left'>{this.props.item.baoCaoTongHopInfo ? this.props.item.baoCaoTongHopInfo.namBaoCao : ''}</td>
        <td className='txt-left'>{this.props.item.hanBaoCao ? moment(this.props.item.hanBaoCao).format('DD/MM/YYYY') : ''}</td>
        <td className='txt-left'>{this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : ''}</td>
        <td className='txt-left'>{this.props.item.ngayGui ? moment(this.props.item.ngayGui).format('DD/MM/YYYY') : ''}</td>
      </tr>
    );
  }
}

export default RowItemBaoCaoDinhKy;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/datatable/RowItemBaoCaoDinhKy.jsx